import angular from 'angular'

export default angular.module('app.ui', [])



// WEBPACK FOOTER //
// ./src/app/ui/module.js